'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _redux = require('../utils/redux');

var _coreDecorators = require('core-decorators');

var _toast = require('./toast');

var _toast2 = _interopRequireDefault(_toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    hide: function hide(args) {
      return dispatch((0, _redux.hide)(args));
    }
  };
};

var ConnectedToast = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = (0, _coreDecorators.autobind)(_class = (_temp2 = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(ConnectedToast, _PureComponent);

  function ConnectedToast() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ConnectedToast);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConnectedToast.__proto__ || (0, _getPrototypeOf2.default)(ConnectedToast)).call.apply(_ref, [this].concat(args))), _this), _this.timer = null, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ConnectedToast, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startTimer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearTimer();
    }
  }, {
    key: 'startTimer',
    value: function startTimer() {
      var _props = this.props,
          duration = _props.duration,
          hide = _props.hide,
          id = _props.id;

      if (duration > 0) {
        this.timer = setTimeout(function () {
          return hide({ id: id });
        }, duration);
      }
    }
  }, {
    key: 'clearTimer',
    value: function clearTimer() {
      clearTimeout(this.timer);
    }
  }, {
    key: 'handleMouseOver',
    value: function handleMouseOver() {
      this.clearTimer();
    }
  }, {
    key: 'handleMouseOut',
    value: function handleMouseOut() {
      this.startTimer();
    }
  }, {
    key: 'hide',
    value: function hide() {
      var _props2 = this.props,
          hide = _props2.hide,
          id = _props2.id;

      this.clearTimer();
      hide({ id: id });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_toast2.default, (0, _extends3.default)({}, this.props, {
        hide: this.hide,
        eventHandlers: {
          onMouseOut: this.handleMouseOut,
          onMouseOver: this.handleMouseOver
        }
      }));
    }
  }]);
  return ConnectedToast;
}(_react.PureComponent), _class2.defaultProps = {
  duration: 3000
}, _temp2)) || _class) || _class);
process.env.NODE_ENV !== "production" ? ConnectedToast.propTypes = {
  text: _propTypes2.default.string,
  duration: _propTypes2.default.number,
  isClosable: _propTypes2.default.bool
} : void 0;
exports.default = ConnectedToast;